import React, { Fragment, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Tab, Nav } from 'react-bootstrap'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, UncontrolledTooltip } from 'reactstrap'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { trans, fetchQueryStringFromUrl, fetchKeysFromQueryString } from '@utils'
import classNames from 'classnames'
import qs from 'qs'
//************************************//
import { EllipsisVerticalIcon, PlusIcon, FloppyDiskIcon, EditIcon, DeleteIcon } from '@src/assets/icons'
import DeleteModal from "@src/components/DeleteModal"
//************************************//
const QueryTabs = (props) => {
  const loading = useSelector(state => state.app.loading)
  const defaultQueries = props.savedQueries.defaultQueries
  const defaultQuery = _.head(defaultQueries)
  const [data, setData] = useState({
    activeQuery: 'default',
    queries: defaultQueries
  })
  const [deleteModal, setDeleteModal] = useState({ show: false, data: null, onDelete: null })
  const onQueryAdd = () => {
    if (props.onQueryAdd) {
      props.onQueryAdd()
    }
  }
  const onQuerySelect = (tabKey) => {
    setData((state) => ({ ...state, defaultQuery: tabKey }))
    if (props.onQuerySelect) {
      props.onQuerySelect(tabKey)
    }
  }
  const onQueryRename = (query) => {
    if (props.onQueryRename) {
      props.onQueryRename(query)
    }
  }
  const onQuerySaveChange = (query) => {
    if (props.onQuerySaveChange) {
      props.onQuerySaveChange(query)
    }
  }
  const openDeleteModal = (query) => {
    setDeleteModal({
      show: true,
      data: null,
      onDelete: () => {
        if (props.onQueryDelete) {
          props.onQueryDelete(query)
        }
      }
    })
  }
  const closeDeleteModal = () => {
    setDeleteModal({
      show: false,
      data: null,
      onDelete: null
    })
  }
  const checkSaveQueryVisible = (isVisible = true) => {
    if (!isVisible) return false
    //
    const urlQueryString = fetchQueryStringFromUrl()
    const urlQueryStringFilter = fetchKeysFromQueryString(urlQueryString, ['filter'])
    //
    const savedQueries = props.savedQueries.data
    const storageQueryString = _.get(savedQueries, `queryString`)
    const storageQueryStringFilter = fetchKeysFromQueryString(storageQueryString, ['filter'])
    //
    const selectedKey = _.get(savedQueries, 'selected_key')
    const selectedQuery = _.get(savedQueries, `queries.${selectedKey}`, {})
    const selectedQueryQueryStringFilter = fetchKeysFromQueryString(selectedQuery.queryString, ['filter'])
    //
    if (loading) {
      return false
    }
    if (urlQueryString) {
      return qs.stringify(urlQueryStringFilter) !== qs.stringify(selectedQueryQueryStringFilter)
    }
    if (storageQueryString) {
      return qs.stringify(storageQueryStringFilter) !== qs.stringify(selectedQueryQueryStringFilter)
    }
    return false
  }
  useEffect(() => {
    setData((state) => ({
      ...state,
      activeQuery: props.savedQueries.data.selected_key || defaultQuery.key
    }))
  }, [props.savedQueries.data.selected_key])
  useEffect(() => {
    const findDefaults = _.filter(props.savedQueries.data.queries, query => query.key === 'default')
    const _defaultQueries = _.size(findDefaults) > 0 ? findDefaults : defaultQueries
    setData((state) => ({
      ...state,
      queries: [
        ..._defaultQueries,
        ..._.values(_.omit(props.savedQueries.data.queries, 'default'))
      ]
    }))
  }, [props.savedQueries.data.queries])
  return (
    <Fragment>
      <div className='d-flex align-items-center'>
        <Tab.Container
          activeKey={data.activeQuery}
          onSelect={onQuerySelect}
        >
          <Nav variant={'tabs'} className={'dataTable-queries-nav nav-left mb-0'}>
            {_.map(data.queries, (query, index) => {
              return (
                <Nav.Item key={index} data-key={query.key} className={classNames({ 'mr-50': data.queries.length - 1 !== index })}>
                  <Nav.Link eventKey={query.key} disabled={loading} className='d-flex justify-content-between align-items-center px-75 pt-0' style={{ overflow: query.key === data.activeQuery ? 'visible' : 'hidden' }}>
                    {checkSaveQueryVisible(query.key === data.activeQuery) && <span className='has-changes bg-warning mx-25'></span>}
                    <UncontrolledTooltip placement='top' target={`tab-${query.key}`}>
                      <div className='d-flex flex-column justify-content-start align-items-start'>
                        <span>{query.key === 'default' ? trans(query.name) : query.name} {checkSaveQueryVisible(query.key === data.activeQuery) && <span>({trans('gen.datatable.saveQueryChangesNote')})</span>}</span>
                      </div>
                    </UncontrolledTooltip>
                    <div id={`tab-${query.key}`} className='dataTable-query-name text-dark text-truncate font-weight-bold text-nowrap p-25'>
                      {query.key === 'default' ? trans(query.name) : query.name}
                    </div>
                    {query.key === data.activeQuery && (
                      <UncontrolledDropdown size={'sm'}>
                        <DropdownToggle className="btn-icon p-25" size="sm" color="flat-primary">
                          <FontAwesomeIcon size='lg' icon={EllipsisVerticalIcon} fixedWidth />
                        </DropdownToggle>
                        <DropdownMenu container="body">
                          <DropdownItem className='d-flex align-items-center w-100 btn-sm rounded-0' onClick={() => onQuerySaveChange(query)} disabled={!checkSaveQueryVisible()}>
                            <FontAwesomeIcon icon={FloppyDiskIcon} fontSize={'16'} />
                            <span className='align-middle ml-50'>{trans('gen.actions.save')}</span>
                          </DropdownItem>
                          {query.key !== 'default' && (
                            <DropdownItem className='d-flex align-items-center w-100 btn-sm rounded-0' onClick={() => onQueryRename(query)}>
                              <FontAwesomeIcon icon={EditIcon} />
                              <span className='align-middle ml-50'>{trans('gen.datatable.rename')}</span>
                            </DropdownItem>
                          )}
                          {query.key !== 'default' && (
                            <DropdownItem className='d-flex align-items-center w-100 btn-sm rounded-0 text-danger' onClick={() => openDeleteModal(query)}>
                              <FontAwesomeIcon icon={DeleteIcon} />
                              <span className='align-middle ml-50'>{trans('gen.actions.delete')}</span>
                            </DropdownItem>
                          )}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    )}
                  </Nav.Link>
                </Nav.Item>
              )
            })}
            <Nav.Item>
              <Button size='sm' className='d-flex align-items-center justify-content-center btn-icon ml-50' color='flat-primary' onClick={onQueryAdd}>
                <FontAwesomeIcon fontSize={18} icon={PlusIcon} className='fa-fw' />
              </Button>
            </Nav.Item>
          </Nav>
        </Tab.Container>

      </div>
      {deleteModal.show && (
        <DeleteModal
          data={{
            title: trans('gen.datatable.deleteQuery'),
            text: trans('gen.datatable.deleteQueryDescription'),
            confirmButtonText: trans("gen.actions.delete"),
            denyButtonText: trans("gen.actions.cancel")
          }}
          onClose={closeDeleteModal}
          onDelete={deleteModal.onDelete}
        />
      )}
    </Fragment>
  )
}

export default QueryTabs